import { Component, OnInit } from '@angular/core';
import { CustomerAccountService } from '../../../core/customer-account/customer-account.service';
import { AllProductLine } from '../../../shared/enums/availableProductList.enum';
@Component({
  standalone: false,
  selector: 'app-waygate-landing',
  templateUrl: './waygate-landing.component.html',
  styleUrls: ['./waygate-landing.component.scss'],
})
export class WaygateLandingComponent implements OnInit {
  productLine: string;
  allProductLine = AllProductLine;
  sapBlocked: boolean = false;
  
  constructor(private customerAccService: CustomerAccountService) {
    this.customerAccService.getMyProfile().subscribe((currentCustomer) => {
      const getsapblocked = currentCustomer;
      this.sapBlocked = currentCustomer?.recentSalesArea?.sapBlocked;
      console.log('getsapblocked' + this.sapBlocked);
    });
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.customerAccService.getProductLine().subscribe((productLine) => {
      this.productLine = productLine;
    });
  }
}